import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.product-slider-products' ).each( ( key, element ) => {
        const slider = new Splide( element, {
          type: 'slide',
          perPage: 4,
          arrows: false,
          pagination: false,
          perMove: 1,
          breakpoints: {
            640: {
              perPage: 1,
            },
            786: {
              perPage: 2,
            },
            1270: {
              perPage: 3,
            },
          },
        } ).mount();

        const prevButton = element.closest( '.product-slider' ).querySelector( '.product-slider-nav-prev' );
        const nextButton = element.closest( '.product-slider' ).querySelector( '.product-slider-nav-next' );

        const updateButtonStates = () => {
          const currentIndex = slider.index;
          const firstIndex = 0;
          const lastIndex = slider.Components.Controller.getEnd();

          prevButton.classList.toggle( 'is-disabled', currentIndex === firstIndex );
          nextButton.classList.toggle( 'is-disabled', currentIndex === lastIndex );
        };

        updateButtonStates();

        prevButton.addEventListener( 'click', () => {
          slider.go( '<' );
        } );

        nextButton.addEventListener( 'click', () => {
          slider.go( '>' );
        } );

        slider.on( 'moved', updateButtonStates );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'product-slider', COMPONENT );
} )( app );
